

export const tuyaTenant = {
  name: 'tuya',
  properties: {
    // Primary colors
    '--primary': '#ff1525',
    '--secondary': '#ffe800',
    '--tertiary': '#ffe800',
    '--quarter': '#54555a',
    '--error': 'red',
    '--nav-bar': '#fff',

    /* Buttons */
    // Primary
    '--color-button-primary': '#000',
    '--bg-color-button-primary': '#ffe201',
    '--hover-color-button-primary': '#fff',
    '--hover-bg-color-button-primary': '#ff1525',
    // Secondary
    '--color-button-secondary': '#000',
    '--bg-color-button-secondary': '#ffe201',
    '--hover-color-button-secondary': '#fff',
    '--bg-hover-color-button-secondary': '#ff1525',
    // Tertiary
    '--color-button-tertiary': '#000',
    '--bg-color-button-tertiary': '#ffe201',
    '--hover-color-button-tertiary': '#fff',
    '--bg-hover-color-button-tertiary': '#ff1525',

    // Forms
    '--color-input-valid': '#00b5cc',

    // Fonts
    '--primary-semibold-font-family': 'FSJoeySemiBold',
    '--font-family-secondary': `'Barlow', sans-serif`,
    '--font-family-secondary-medium': `'Barlow', sans-serif`,

    // Header
    '--background-header': '#fff',
    '--color-breadcrumb': '#b69e62',
    '--color-breadcrumb-sucess': '#ed1c29',
    '--logo': 'url(../../../../assets/images/tenants/tuya/logo.png)',

    // Footer
    '--footer-color': '#fff',

    // SOAT
    '--color-tittle-h2': 'var(--primary)',
    '--color-tittle-h3': 'var(--primary)',
  }
};
